import {
  deleteUser,
  getUsers,
  storeUser,
  updatePassword,
  updateUser
} from "../api-helpers/api-users";
import { UsersIndexTabs } from "../js-data/tab-groups";
import { UserTypes } from "../constants/user-enums";

export default {
  state: {
    indexTabs: UsersIndexTabs,
    isGettingUsers: false,
    users: null,
    isGettingUsersOfSpecifiedTypes: false,
    usersOfSpecifiedTypes: null,
    isGettingCrewSupervisors: false,
    crewSupervisors: null,
    isGettingCrewLeaders: false,
    crewLeaders: null,
    isStoringUser: false,
    isUpdatingUser: false,
    isDeletingUser: false
  },
  mutations: {
    setUsersIndexTabCounts(state, counts) {
      state.indexTabs = state.indexTabs.map(tab => {
        tab.count = counts[tab.slug];
        return tab;
      });
    },
    setIsGettingUsers(state, bool) {
      state.isGettingUsers = bool;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setIsGettingUsersOfSpecifiedTypes(state, bool) {
      state.isGettingUsers = bool;
    },
    setUsersOfSpecifiedTypes(state, users) {
      state.usersOfSpecifiedTypes = users;
    },
    setIsGettingCrewSupervisors(state, bool) {
      state.isGettingCrewSupervisors = bool;
    },
    setCrewSupervisors(state, users) {
      state.crewSupervisors = users;
    },
    setIsGettingCrewLeaders(state, bool) {
      state.isGettingCrewLeaders = bool;
    },
    setCrewLeaders(state, users) {
      state.crewLeaders = users;
    },
    setIsStoringUser(state, bool) {
      state.isStoringUser = bool;
    },
    setIsUpdatingUser(state, bool) {
      state.isUpdatingUser = bool;
    },
    setIsDeletingUser(state, bool) {
      state.isDeletingUser = bool;
    }
  },
  actions: {
    async getUsers({ state, commit }, types) {
      let usersAndCounts;
      if (
        (!types && !state.isGettingUsers) ||
        (types && types.length && !state.isGettingUsersOfSpecifiedTypes)
      ) {
        if (types && types.length) {
          commit("setIsGettingUsersOfSpecifiedTypes", true);
        } else {
          commit("setIsGettingUsers", true);
        }

        usersAndCounts = await getUsers(types);
        if (types && types.length) {
          commit("setUsersOfSpecifiedTypes", usersAndCounts.users);
        } else {
          commit("setUsers", usersAndCounts.users);
        }
        commit("setUsersIndexTabCounts", usersAndCounts.counts);

        if (types && types.length) {
          commit("setIsGettingUsersOfSpecifiedTypes", false);
        } else {
          commit("setIsGettingUsers", false);
        }
      }
      return usersAndCounts;
    },
    async getCrewSupervisors({ state, commit }) {
      let crewSupervisorsAndCounts;
      if (!state.isGettingCrewSupervisors) {
        commit("setIsGettingCrewSupervisors", true);

        crewSupervisorsAndCounts = await getUsers(UserTypes.CREW_SUPERVISOR);
        commit("setCrewSupervisors", crewSupervisorsAndCounts.users);
        commit("setUsersIndexTabCounts", crewSupervisorsAndCounts.counts);

        commit("setIsGettingCrewSupervisors", false);
      }
      return crewSupervisorsAndCounts;
    },
    async getCrewLeaders({ state, commit }) {
      let crewLeadersAndCounts;
      if (!state.isGettingCrewLeaders) {
        commit("setIsGettingCrewLeaders", true);

        crewLeadersAndCounts = await getUsers(UserTypes.CREW_LEADER);
        commit("setCrewLeaders", crewLeadersAndCounts.users);
        commit("setUsersIndexTabCounts", crewLeadersAndCounts.counts);

        commit("setIsGettingCrewLeaders", false);
      }
      return crewLeadersAndCounts;
    },
    async storeUser({ state, rootState, commit, dispatch }, user) {
      let response;
      if (!state.isStoringUser) {
        commit("setIsStoringUser", true);

        response = await storeUser(user);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "User created successfully.",
          errorText: "An error occurred while attempting to create User.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchUsers", rootState.Search.searchTerm);
            } else {
              dispatch("getUsers");
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsStoringUser", false);
      }
      return response;
    },
    async updateUser({ state, rootState, commit, dispatch }, user) {
      let response;
      if (!state.isUpdatingUser) {
        commit("setIsUpdatingUser", true);

        response = await updateUser(user);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "User updated successfully.",
          errorText: "An error occurred while attempting to update User.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchUsers", rootState.Search.searchTerm);
            } else {
              dispatch("getUsers");
            }
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingUser", false);
      }
      return response;
    },
    async deleteUser({ state, rootState, commit, dispatch }, user) {
      let response;
      if (!state.isDeletingUser) {
        commit("setIsDeletingUser", true);

        response = await deleteUser(user);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "User deleted successfully.",
          errorText: "An error occurred while attempting to delete User.",
          afterSuccessFunction: () => {
            if (rootState.Search.areSearchResultsShown) {
              dispatch("searchUsers", rootState.Search.searchTerm);
            } else {
              dispatch("getUsers");
            }
            commit("resetConfirmationModalParams");
          }
        });

        commit("setIsDeletingUser", false);
      }
      return response;
    },
    async updatePassword({ state, commit, dispatch }, data) {
      let response;
      if (!state.isUpdatingPassword) {
        commit("setIsUpdatingPassword", true);

        response = await updatePassword(data);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Password updated successfully.",
          errorText: "An error occurred while attempting to update password.",
          afterSuccessFunction: () => {
            commit("resetModalParams");
          }
        });

        commit("setIsUpdatingPassword", false);
      }
      return response;
    }
  }
};
